import { ArrowDownwardTwoTone, ArrowUpwardTwoTone, BreakfastDining, CardTravel, GifBox, Summarize } from '@mui/icons-material';
import GetAppIcon from '@mui/icons-material/GetApp';
import { IconButton, List, Paper, Stack, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, Toolbar, Typography } from "@mui/material";
import { FC, useEffect, useRef, useState } from "react";
import { ComponentToPrintContainer } from './Print';
import { PrintAction } from "./PrintActions";



export const ListActionsContainer: FC<{ data: any[], name: string, phone: string, quantity: number, record: any, }> = ({ data, name, phone, quantity, record }) => {


  const printRef = useRef<HTMLDivElement>(null);

  // Parse quantities and calculate totals



  const handlePrint = (id: number) => {
    console.log({ id });
  }

  const [searchDate, setSearchDate] = useState('');
  const handleExportExcel = () => {
    // Implement export to Excel logic here
  };

  const handlePrintInvoice = () => {
    // Implement print invoice logic here
  };

  useEffect(() => {
    if (printRef.current) {
      // Call the print action when the component has mounted and ref is available
      const printAction = () => {
        const printWindow = window.open('', '_blank');
        if (printWindow) {
          printWindow.document.write('<html><head><title>Print</title></head><body>');
          // printWindow.document.write(printRef.current?.innerHTML);
          printWindow.document.write('</body></html>');
          printWindow.document.close();
          printWindow.print();
        }
      };

      printAction();
    }
  }, []);

  const getTotalQuantities = (type: string) => {
    return (data || []).reduce((total, item) => {
      if (item.type === type) {
        return total + parseInt(item.quantity, 10);
      }
      return total;
    }, 0);
  };


  const purchasesTotal = record?.purshases.reduce((total: any, purchase: any) => total + parseInt(purchase.quantity, 10), 0);
  const cassesTotal = record?.casses.reduce((total: any, casse: any) => total + parseInt(casse.quantity, 10), 0);
  const actionsTotal = record?.actions.reduce((total: any, action: any) => total + parseInt(action.quantity, 10), 0);

  const totalInQuantity = getTotalQuantities("in");
  const totalOutQuantity = getTotalQuantities("out");
  const availableQuantity = (purchasesTotal + totalInQuantity - totalOutQuantity - cassesTotal) ?? 0;
  

  const _data = [
    { icon: <ArrowUpwardTwoTone fontSize="small" sx={{ color: 'red' }} />, label: 'Out', quantity: totalOutQuantity ?? 0 },
    { icon: <ArrowDownwardTwoTone fontSize="small" sx={{ color: 'green' }} />, label: 'In', quantity: totalInQuantity ?? 0 },
    { icon: <CardTravel fontSize="small" sx={{ color: 'blue' }} />, label: 'Purshase', quantity: purchasesTotal ?? 0 }, // Total of purshase
    { icon: <BreakfastDining fontSize="small" sx={{ color: 'orange' }} />, label: 'Casse', quantity: cassesTotal ?? 0 }, // total of casse
    { icon: <Summarize />, label: 'Total actions quantity', quantity: (totalOutQuantity + totalInQuantity) ?? 0 }, // out + in
    { icon: <GifBox />, label: 'Available quantity', quantity: availableQuantity ?? 0 }, // Purshase + in - out - casse
  ];




  return (
    <Stack>
      <TableContainer component={Paper} sx={{ maxWidth: 400 }}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Label</TableCell>
              <TableCell>Quantity</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {_data.map((row) => (
              <TableRow key={row.label}>
                <TableCell>
                  <IconButton>
                    {row.icon}
                  </IconButton>
                  {row.label}
                </TableCell>
                <TableCell>{row.quantity}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <List>
        <Stack direction="row" alignItems="center" justifyContent="space-between" px={4} mb={2} mt={5}>
          <Typography variant="body1" fontWeight="bold" >
            Actions
          </Typography>
          <Stack direction="row" alignContent="end" justifyContent="end" mb={2}>
            <Toolbar>
              <TextField
                label="Search"
                value={searchDate}
                onChange={(e) => setSearchDate(e.target.value)}
                variant="outlined"
              // sx={{ mr: 2 }}
              />
              <IconButton onClick={handleExportExcel}>
                <GetAppIcon />
              </IconButton>
              <ComponentToPrintContainer
                headerInfo={{
                  name: name, phone:
                    phone
                }}
                data={data || []}
              />
            </Toolbar>
          </Stack>

        </Stack>
        <Stack direction="column" alignItems="start" spacing={2}>
          <Stack direction="row" alignItems="flex-start" spacing={2} width="100%">
            <Stack direction="column" alignItems="flex-start" spacing={2}>
              <Typography variant="body2" fontWeight="bold" >
                <Stack alignItems="center" direction="row" spacing={2}>
                  <ArrowDownwardTwoTone fontSize="small" sx={{ color: 'green' }} />
                  <span>
                    IN
                  </span>
                </Stack>
              </Typography>
              <TableContainer component={Paper}>
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell>Quantity</TableCell>
                      <TableCell>Facture</TableCell>
                      <TableCell>Product</TableCell>
                      <TableCell>Date</TableCell>
                      <TableCell>Action</TableCell>
                    </TableRow>
                  </TableHead>
                  {(data || []).filter((item: any) => item.type === "in").map((action: any, index: number) => (
                    <PrintAction action={action} key={index} />
                  ))}
                </Table>
              </TableContainer>
            </Stack>
            <Stack direction="column" alignItems="flex-start" spacing={2}>
              <Stack alignItems="center" direction="row" spacing={2}>
                <ArrowUpwardTwoTone fontSize="small" sx={{ color: 'red' }} />
                <span>
                  OUT
                </span>
              </Stack>
              <TableContainer component={Paper}>
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell>Quantity</TableCell>
                      <TableCell>Facture</TableCell>
                      <TableCell>Product</TableCell>
                      <TableCell>Date</TableCell>
                      <TableCell>Action</TableCell>
                    </TableRow>
                  </TableHead>
                  {(data || []).filter((item: any) => item.type === "out").map((action: any, index: number) => (
                    <PrintAction action={action} key={index} />
                  ))}
                </Table>
              </TableContainer>
            </Stack>
          </Stack>
        </Stack>
      </List>
    </Stack>

  )
}
